module.exports = __webpack_public_path__ + "static/media/pup_Logo.7f588e54.png";